// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3V3rR","dragIcon":"Choice_dragIcon__ENxYQ","left":"Choice_left__1d676","input":"Choice_input__ax--D"};